function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawCreditCardPayments = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1084 830.5",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 637.43,
    y1: 864.75,
    x2: 637.43,
    y2: 34.75,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 981.72,
    y1: 454.26,
    x2: 981.72,
    y2: 316.75,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M94.13 383.85c-15 4.9-29 16.76-32.78 33.21-4.29 18.9 5.59 38 7 57.38 4.61 63.61-79.13 108.49-67.19 171 4.75 24.81 23.93 43.1 42.84 58.15 30.27 24.11 63.85 45.4 101 51.42 56.44 9.13 115.42-17.73 170.29-.75 44.25 13.69 78.11 53.83 122.06 68.64 33.46 11.28 69.49 6.83 104.28 2.27 18.71-2.45 38.37-5.29 53.5-17.44 28.17-22.62 29.87-67.28 48.71-99.29 29.07-49.41 92.81-59.06 146.26-49.46s105.32 33.27 159.47 31.27c11.57-.41 23.44-2.12 33.52-8.25 12.27-7.46 20.57-20.59 27.9-33.59 45.68-81 71.13-175.22 72.94-270.07.31-16.39-.22-33.49-7.35-48-9-18.31-27-29.24-45-36.62-43.08-17.62-90.67-20.47-132.9-40.47-40.73-19.27-73.73-53.08-109.19-82-70.33-57.45-153-97.21-239.52-115.26-20.37-4.25-41.51-7.29-61.75-2.38-23.32 5.66-43.42 21.37-61.49 38.27-48.09 45-86.62 100.48-130.92 149.78a765.11 765.11 0 0 1-99.49 92.59c-16.43 12.77-33.83 27.93-52.1 37.37-16.71 8.63-32.42 6.46-50.09 12.23z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1072.55 451c-22-4.6-63.65-13.23-110.79-22.79-69.79-14.15-88 39.41-88 39.41 0 27.28-91 140.44-91 140.44l-27.14-60.8a28.62 28.62 0 0 0 12.48-.84c15.54-4.64 23.22-22.17 25.71-38.18a125.46 125.46 0 0 0-9.77-71c-4.63-10.14-10.63-19.68-14.35-30.18C754 363 781.18 312 764.74 268.11c-6.79-18.11-20.33-32.8-29.69-49.72-21-38.05-20.1-85.65-43-122.61-21.48-34.65-63.81-55.19-104.36-50.61-23.91 2.7-41 11.24-63.28 1-18.81-8.62-41.39-18.26-60.76-4.68-16.52 11.58-19.33 34.39-28.35 52.42-15.84 31.67-53.42 52.34-57.84 87.47-1.09 8.66 0 17.64-2.53 26-7.22 23.63-38.66 30.61-51.54 51.7-12.61 20.64.13 51.85 23.59 57.8 10 2.54 20.76 1 30.75 3.69 9.37 2.5 18.46 11.26 16.84 20.41l-20.78 3.78L314 351.4l-9.25.58v.45l-.5.06.49.4v3.28c-16.83 6.59-44.1 24.18-54.4 70.32a69.84 69.84 0 0 1-13.93 28.75c-15.33 18.9-40.77 55.81-39.35 91.24 2 50.52 2 70.73 68.78 56.58 16.87-3.57 35.22-10.89 53.23-19.83 1.05 21.06 3.78 41.71 9.48 57.21 18.21 49.51-20.23 224.31-20.23 224.31h371.23s-31.36-103.06-61.7-155.6c-21.49-37.22-13.55-59.73-7.09-69.7a93.56 93.56 0 0 0 12.39-27.62c1.1-4.31 2.17-9.2 3.09-14.62 6.83 5.59 14.12 10.61 22.37 13.61 7.64 2.77 16.33 3.53 24.06 1.39 15.82 19.34 33.49 40.55 52.4 62.59 72.83 84.87 93.06 32.33 93.06 32.33s73.84-140.44 84-182.88 32.37-40.42 32.37-40.42c60.88 15.39 114.84-6.95 139.91-20.39a6.67 6.67 0 0 0-1.86-12.44zm-751.12 25.39a96.07 96.07 0 0 0 13-19h.19a144.31 144.31 0 0 1-7.11 20.68c-5.67 1.09-9.09 1.66-9.09 1.66z",
    transform: "translate(-58 -34.75)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M403 15.73c-16.33 11.46-19.11 34-28 51.88-15.66 31.34-52.81 51.81-57.18 86.57-1.08 8.57 0 17.46-2.5 25.72-7.13 23.39-38.22 30.3-51 51.17-12.47 20.42.13 51.31 23.32 57.2 9.91 2.52 20.52 1 30.4 3.65s19.45 12.33 16.18 22c-2.43 7.2-11 11.3-12.56 18.74-1.36 6.4 3 12.5 7.22 17.48 5.36 6.3 11.08 12.5 18.25 16.63 19.72 11.36 44.32 4.54 67.06 3.79a121.17 121.17 0 0 1 76.47 24.31c6.29 4.77 12.21 10.28 16.11 17.15 12.71 22.38.69 50.47 3.39 76.06 3.06 29.08 24.78 52.42 46.71 71.75 8.76 7.72 18 15.33 29 19.32s24.15 3.77 33.4-3.35c9.72-7.48 13.1-20.73 13.16-33s-2.52-24.48-1.9-36.73c.3-6 2.49-13.13 8.34-14.31 2.93-.59 5.9.6 8.57 1.94 18.66 9.38 36.56 27.75 56.56 21.79 15.37-4.59 23-21.94 25.42-37.79a124.29 124.29 0 0 0-9.66-70.24c-4.58-10-10.51-19.47-14.19-29.87-15.46-43.69 11.39-94.18-4.85-137.59-6.71-17.92-20.1-32.46-29.35-49.21-20.8-37.66-19.87-84.77-42.52-121.35-21.23-34.3-63.09-54.62-103.17-50.09-23.64 2.67-40.53 11.13-62.56 1-18.6-8.51-40.92-18.1-60.12-4.62z",
    fill: "#40243e"
  }), React.createElement("path", {
    d: "M561.5 332.5s65-20 91 96l66 148s90-112 90-139c0 0 18-53 87-39 46.61 9.46 87.74 18 109.53 22.55a6.6 6.6 0 0 1 1.79 12.27c-24.78 13.3-78.13 35.41-138.32 20.18 0 0-22-2-32 40s-83 181-83 181-20 52-92-32-126-156-126-156z",
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M561.5 346.5l-8.62 28.39-8.52 28.08-16.86 55.53-80 15-26.07-16.63-31.93-20.37-27.53-19-40.47-28-33-69s9.1-1.61 37.47-6.77l39.53-7.23c27.3-5 37.62-25.32 40.77-46 3.77-24.76-2.77-50-2.77-50h101s11.3 17 9.53 46.36a117.53 117.53 0 0 1-4.53 25.64c-8.88 30.74 11.17 41 24.77 44.33a56.37 56.37 0 0 0 11.23 1.67z",
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M514 256.86a95.06 95.06 0 0 1-107.76 3.66c3.77-24.76-2.77-50-2.77-50h101s11.33 16.93 9.53 46.34z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 457.5,
    cy: 177.5,
    r: 95,
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M561.5 346.5l-8.62 28.39-8.52 28.08-16.86 55.53-80 15-26.07-16.63-31.93-20.37-27.53-19-40.47-28-33-69s9.1-1.61 37.47-6.77c20 55.65 45.3 76.37 68.13 83.09 13.65 4 26.41 3 36.58 1.5a94.39 94.39 0 0 1 39.23 2c30.7 8.54 46.86-7.81 55.35-28.56 6.28-15.35 8.36-33.12 9-45a56.37 56.37 0 0 0 11.23 1.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M249.5 830.5s38-173 20-222c-5.15-14-7.85-32.32-9.06-51.28-3-47.27 3.06-98.72 3.06-98.72.86-1.67 1.67-3.33 2.45-5q3-6.4 5.28-12.52c21.43-57.66-5.23-96.05-18.75-110.73a67.33 67.33 0 0 0-7-6.73l76.5-8.5c20.11 57.71 45.9 79 69.1 85.82 13.65 4 26.41 3 36.58 1.5a94.39 94.39 0 0 1 39.23 2c30.7 8.54 46.86-7.81 55.35-28.56 10.54-25.76 9.24-58.29 9.24-58.29l44 13s-3.88 24.1-7.39 55.77c-.83 7.43-1.64 15.27-2.37 23.32-3 33.58-4.78 70.71-1.24 95.91a194.05 194.05 0 0 1-3.77 74.68 92.61 92.61 0 0 1-12.24 27.34c-6.39 9.86-14.24 32.15 7 69 30 52 61 154 61 154z",
    fill: "#ff808e"
  }), React.createElement("path", {
    d: "M575 331s36.33 57-11.34 106S535 417 535 417l12-80z",
    fill: "#ff808e"
  }), React.createElement("path", {
    d: "M252.48 330.25a49.46 49.46 0 0 1 8.31-1.86c13 6.2 20.2 23.41 24.11 41.38a93.06 93.06 0 0 1-13.67 71.26c21.43-57.71-5.23-96.1-18.75-110.78zM565.74 409.59c-21.35 1.41-49.24-1.09-49.24-1.09 3.76 17.2-4 30.64-12 39.4a27.26 27.26 0 0 1-24.66 8.63c-46.14-8-116.3 34-116.3 34s-50.18 40.53-103.1 66.72c-3-47.27 3.06-98.72 3.06-98.72.86-1.67 1.67-3.33 2.45-5 21.38-4 99.06-19.8 114.55-43 2.3-3.45 6-6.68 10.6-9.68 13.23-8.56 34.4-15.27 54.53-20.17a217.78 217.78 0 0 1 76.63-4.86 211.39 211.39 0 0 1 32.56 6.35c4.66 1.29 9.16 2.68 13.29 4.13 11.32 4 19.9 8.47 21.39 13.23 2.01 6.4-9.4 9.12-23.76 10.06z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M544.36 402.97c-15.39-.26-28.86-1.47-28.86-1.47 3.76 17.2-4 30.64-12 39.4a27.26 27.26 0 0 1-24.66 8.63c-17.39-3-38.2 1.09-57.37 7.34L389.5 436.5l-27.53-19c8-4.29 14.19-9 17.53-14 8.88-13.32 38-23.23 65.13-29.85a216.08 216.08 0 0 1 108.25 1.24l.94.25c17.39 4.85 32.65 10.86 34.68 17.36 2.92 9.35-22.5 10.85-44.14 10.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M259.79 323.37s-52.31 5.32-67.56 73.13a70.25 70.25 0 0 1-13.9 28.8c-15.16 18.73-40.23 55.2-38.83 90.21 2 50 2 70 68 56s155-86 155-86 70.16-41.93 116.3-34a27.28 27.28 0 0 0 24.66-8.63c8-8.76 15.81-22.2 12-39.4 0 0 78 7 73-9-2-6.5-17.29-12.51-34.68-17.35a216.23 216.23 0 0 0-109.19-1.5c-27.18 6.63-56.25 16.54-65.13 29.85-18 27-120 44-120 44l3-3.37a93.43 93.43 0 0 0 21.44-81.36c-3.9-17.97-11.07-35.18-24.11-41.38z",
    fill: "#ffbcc8"
  }), React.createElement("path", {
    d: "M246 323s-3 121 42 103 10-103 10-103l-20-2z",
    fill: "#ff808e"
  }), React.createElement("path", {
    d: "M380.67 179.13A442.28 442.28 0 0 0 468 160.36c7.3-2.36 15.23-5.5 18.64-12.36.88-1.77 1.54-3.87 3.27-4.84 1.47-.83 3.29-.57 4.94-.19 9.75 2.31 18.12 8.42 27.41 12.17s21.12 4.63 28.26-2.41c8.43-8.32 5.64-22.62.09-33.07C530 80.78 481.72 63.03 437.8 66.25c-6.17.45-12.44 1.28-18 4-11.76 5.65-18.2 18.22-24.57 29.61-12.39 22.09-77.9 86.28-14.56 79.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M380.67 176.13A442.28 442.28 0 0 0 468 157.36c7.3-2.36 15.23-5.5 18.64-12.36.88-1.77 1.54-3.87 3.27-4.84 1.47-.83 3.29-.57 4.94-.19 9.75 2.31 18.12 8.42 27.41 12.17s21.12 4.63 28.26-2.41c8.43-8.32 5.64-22.62.09-33.07C530 77.78 481.72 60.03 437.8 63.25c-6.17.45-12.44 1.28-18 4-11.76 5.65-18.2 18.22-24.57 29.61-12.39 22.09-77.9 86.28-14.56 79.27z",
    fill: "#40243e"
  }), React.createElement("path", {
    d: "M1083.24 316.75h-203a9.25 9.25 0 0 0-9.25 9.25v119a9.25 9.25 0 0 0 9.25 9.25h203a9.25 9.25 0 0 0 9.25-9.25V326a9.25 9.25 0 0 0-9.25-9.25z",
    transform: "translate(-58 -34.75)",
    fill: "url(#prefix__b)"
  }), React.createElement("rect", {
    x: 815.56,
    y: 283.62,
    width: 216.33,
    height: 134.27,
    rx: 11.91,
    ry: 11.91,
    fill: primaryColor
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M815.56 307.12h216.33v24.62H815.56z"
  }), React.createElement("path", {
    opacity: 0.3,
    d: "M815.56 307.12h216.33v24.62H815.56z"
  }), React.createElement("path", {
    fill: "#d6d6e3",
    d: "M836.07 350.01h175.3v11.94h-175.3z"
  }), React.createElement("circle", {
    cx: 850.62,
    cy: 391.78,
    r: 17.16,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 850.62,
    cy: 391.78,
    r: 17.16,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M253 450s-19 10.09-22.15 22.42S224 487 224 487M719 576s-9 31 0 35M270 611s78 17 136-18h25s75 38 111 27",
    opacity: 0.05
  }), React.createElement("path", {
    fill: "#8ed16f",
    d: "M808.575 585.523L823.7 550.87l67.528 29.474-15.126 34.653z"
  }), React.createElement("ellipse", {
    cx: 907.67,
    cy: 618.08,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 852.178 645.009)",
    fill: "#8ed16f"
  }), React.createElement("ellipse", {
    cx: 907.67,
    cy: 618.08,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 852.178 645.009)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#8ed16f",
    d: "M907.604 462.063l15.125-34.653 67.528 29.474-15.125 34.653z"
  }), React.createElement("ellipse", {
    cx: 1006.69,
    cy: 494.62,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 951.203 521.542)",
    fill: "#8ed16f"
  }), React.createElement("ellipse", {
    cx: 1006.69,
    cy: 494.62,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 951.203 521.542)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#8ed16f",
    d: "M1005.572 560.1l37.104-7.272 14.172 72.304-37.103 7.273z"
  }), React.createElement("ellipse", {
    cx: 1088.72,
    cy: 627.51,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-11.09 880.48 908.714)",
    fill: "#8ed16f"
  }), React.createElement("ellipse", {
    cx: 1088.72,
    cy: 627.51,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-11.09 880.48 908.714)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#8ed16f",
    d: "M894.065 755.15l15.125-34.652 67.528 29.474-15.125 34.653z"
  }), React.createElement("ellipse", {
    cx: 993.17,
    cy: 787.7,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 937.692 814.627)",
    fill: "#8ed16f"
  }), React.createElement("ellipse", {
    cx: 993.17,
    cy: 787.7,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 937.692 814.627)",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#8ed16f",
    d: "M727.214 722.402l15.125-34.653 67.528 29.475-15.125 34.653z"
  }), React.createElement("ellipse", {
    cx: 826.32,
    cy: 754.96,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 770.83 781.892)",
    fill: "#8ed16f"
  }), React.createElement("ellipse", {
    cx: 826.32,
    cy: 754.96,
    rx: 7.76,
    ry: 15.51,
    transform: "rotate(-66.42 770.83 781.892)",
    opacity: 0.1
  }));
};

UndrawCreditCardPayments.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawCreditCardPayments;